<template>
  <FormSection
    :title="$t('FINANCE.SALES_INVOICE.FILE_TITLE')"
    :description="$t('FINANCE.SALES_INVOICE.FILE_DESC')"
  >
    <Card>
      <ElForm label-position="top">
        <ElFormItem :label="$t('FROM_DATE')">
          <UiDatePicker
            :default-date="lastMonthDate"
            @select-date="setFromDate"
          />
        </ElFormItem>

        <ElFormItem :label="$t('TO_DATE')">
          <UiDatePicker :default-date="currentDate" @select-date="setToDate" />
        </ElFormItem>

        <ErrorsList v-if="salesFileErrors" :errors="salesFileErrors" />

        <ElButton
          type="primary"
          native-type="submit"
          :loading="salesProcessing"
          :disabled="!dateRange.from || !dateRange.to"
          @click.native.prevent="downloadSalesFile(dateRange)"
        >
          <i class="material-icons">
            file_download
          </i>
          <span>{{ $t('DOWNLOAD_FILE') }}</span>
        </ElButton>

        <SalesReportsSendToEmailButton
          :title="$t('ADVERTISEMENT.FINANCE.SALES_FILE.SEND_TO_EMAIL')"
          :loading="isFileSendingToEmail"
          @sendToEmail="sendToEmail"
        />
      </ElForm>
    </Card>
  </FormSection>
</template>

<script>
import FileSaver from 'file-saver';

import { SalesFile } from '@/api/api';

import FormSection from '@@/common/layout/FormSection';
import Card from '@@/common/Card';

import ErrorsList from '@@/common/ErrorsList';
import UiDatePicker from '@@/layout/UiDatePicker';

import SalesReportsSendToEmailButton from './common/SalesReportsSendToEmailButton';

export default {
  name: 'SalesReportsFile',

  components: {
    FormSection,
    Card,
    UiDatePicker,
    ErrorsList,
    SalesReportsSendToEmailButton,
  },

  data() {
    return {
      dateRange: {
        from: '',
        to: '',
      },
      salesProcessing: false,
      isFileSendingToEmail: false,
      salesFileErrors: null,
    };
  },

  computed: {
    lastMonthDate() {
      const date = new Date();
      return date.setMonth(date.getMonth() - 1);
    },
    currentDate() {
      return Date.now();
    },
  },

  methods: {
    downloadSalesFile(dateRange = {}) {
      this.salesProcessing = true;

      return SalesFile.getSalesFile(dateRange)
        .then(response => response.blob())
        .then(salesFileBlob => {
          FileSaver.saveAs(
            salesFileBlob,
            `sales-file_${dateRange.from}_${dateRange.to}.xlsx`,
          );
          this.salesFileErrors = null;
        })
        .catch(({ body: { message, errors } = {} }) => {
          if (message) {
            this.$message.error(message);
          }
          if (errors) {
            this.salesFileErrors = [...errors];
          }
        })
        .then(() => {
          this.salesProcessing = false;
        });
    },

    sendToEmail(email) {
      this.isFileSendingToEmail = true;

      return SalesFile.sendSalesFileToEmail({
        range: this.dateRange,
        email,
      })
        .then(() => {
          this.$message.success(
            this.$t('ADVERTISEMENT.FINANCE.SEND_TO_EMAIL.SUCCESSFUL'),
          );
        })
        .catch(({ message }) => {
          this.$message.error(message);
        })
        .finally(() => {
          this.isFileSendingToEmail = false;
        });
    },

    setFromDate(selectedDate) {
      this.dateRange.from = selectedDate;
    },

    setToDate(selectedDate) {
      this.dateRange.to = selectedDate;
    },
  },
};
</script>
